import { render, staticRenderFns } from "./FirstColumn.vue?vue&type=template&id=6dbdb1f2&scoped=true"
import script from "./FirstColumn.vue?vue&type=script&lang=js"
export * from "./FirstColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbdb1f2",
  null
  
)

export default component.exports